import commonFn from '@/commons/commonFunction';
import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';
import { useContextStore } from '@/stores/context';
class ReportCustomAPI extends BaseAPI {
  apiName = 'Business';
  controllerName = 'ReportCustomPrints';

  /**
   * hàm xử lý dữ liệu trước khi in báo cáo backend
   * Mục tiêu 1: Set cache param
   * Xử lý dữ liệu sau này
   * @param {*} data 
   */
  async beforePrintBE(param) {
    param.ContextData = useContextStore().Context;
    let apiUrl = this.getAPIUrl();
    let config = {
      url: apiUrl + '/BeforePrint',
      data: param
    };
    return await httpClient.postAsync(config);
  }

  /**
   * Build URL mẫu hiển thị thuyết minh 
   * @returns
   */
  buildUrlReport(cacheKey, fileName, ext) {
    let name = commonFn.removeUnicode(fileName);
    return this.getAPIUrl() + `/view/${cacheKey}/${name}.${ext}`;
  }
  /**
   * Lấy link 
   * @param {string} key 
   */
  getAPIUrl() {
    return [window._apis.Business, this.controllerName].join('/');
  }

}

export default new ReportCustomAPI();
